<div class="table-container-2">
    <h2 class="mat-h2">Authority Contacted</h2>
    <form [formGroup]="form" class=" mt-4">
      <div class="form-container">
        <div class="field-container">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Organization</mat-label>
            <input #Organization matInput formControlName="organizationName" data-test="authorityName-form-field" />
          </mat-form-field>
        </div>
        <div class="field-container">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Officer's Name</mat-label>
            <input matInput formControlName="officerName" data-test="authorityName-form-field" />
          </mat-form-field>
        </div>
        <div class="field-container">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Badge Number</mat-label>
            <input
              matInput
              formControlName="badgeNumber"
              data-test="badgeNumber-form-field"
            />
          </mat-form-field>
        </div>
        <div class="field-container">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Report Number</mat-label>
            <input
              matInput
              formControlName="reportNumber"
              data-test="reportNumber-form-field"
            />
          </mat-form-field>
        </div>
        <div class="field-container">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Violations/Citations</mat-label>
            <textarea
              matInput
              formControlName="violations"
              maxlength="200"
              data-test="violations-form-field"
              matTextareaAutosize
              matAutosizeMinRows="6"
            ></textarea>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
  